import { render, staticRenderFns } from "./PanelEmbed.vue?vue&type=template&id=115852d1&scoped=true&"
import script from "./PanelEmbed.vue?vue&type=script&lang=js&"
export * from "./PanelEmbed.vue?vue&type=script&lang=js&"
import style0 from "./PanelEmbed.vue?vue&type=style&index=0&id=115852d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115852d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115852d1')) {
      api.createRecord('115852d1', component.options)
    } else {
      api.reload('115852d1', component.options)
    }
    module.hot.accept("./PanelEmbed.vue?vue&type=template&id=115852d1&scoped=true&", function () {
      api.rerender('115852d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/PanelEmbed.vue"
export default component.exports